import {
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../../common/components/AppSpinner';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import ProfileDetails from '../../components/ProfileDetails/ProfileDetails';
import ProfileSelectBox from '../../components/ProfileSelectBox/ProfileSelectBox';
import ProfileStore from '../../store/profiles';
import ButtonGroup from '../ButtonGroup/ButtonGroup';

import CustomTooltip from '../../../common/components/CustomTooltip';
import { switchBetweenActiveProfiles } from '../../actions/profiles-actions/profile-state-actions';

const ProfileSelectionPanel: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { profileInContext, activeProfileId } = useSnapshot(ProfileStore);
  const { loadingProfileOverview } = useSnapshot(PoliciesProfileUIStateStore);

  if (loadingProfileOverview)
    return (
      <Stack
        mt={1}
        justifyContent='center'
        alignItems='center'
        direction='row'
        minHeight={133}>
        <AppSpinner text='Loading profile...' disablePositionAbsolute />
      </Stack>
    );
  return (
    <Stack
      p={1.5}
      spacing={1.5}
      flexDirection='column'
      display='flex'
      alignItems='flex-start'>
      <Stack
        width='100%'
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'>
        <Typography textAlign='justify' variant='h6' color='primary'>
          Policies Selection
        </Typography>
        {profileInContext && <ButtonGroup />}
      </Stack>
      <Divider flexItem />
      <Stack
        width='100%'
        flexDirection='row'
        display='flex'
        flexGrow={1}
        gap={1}>
        {profileInContext && (
          <Stack flexGrow={1} spacing={1} direction='row'>
            <ProfileSelectBox profileIdInContext={profileInContext.profileId} />
            <CustomTooltip
              title={`Set ${profileInContext?.profileName} profile as active`}>
              <FormControlLabel
                value={profileInContext.active}
                control={
                  <Checkbox
                    disabled={profileInContext?.profileId === activeProfileId}
                    name='active'
                    size='small'
                    color='primary'
                    inputProps={{ 'aria-label': 'Set active' }}
                    checked={profileInContext.active}
                    onChange={(
                      _event: React.ChangeEvent<HTMLInputElement>,
                      checked: boolean,
                    ) => {
                      switchBetweenActiveProfiles(checked);
                    }}
                  />
                }
                label='Set as active profile'
                labelPlacement='end'
              />
            </CustomTooltip>
          </Stack>
        )}
      </Stack>
      {profileInContext && (
        <ProfileDetails profileInContext={profileInContext} />
      )}
    </Stack>
  );
};

export default ProfileSelectionPanel;
